import React, { useState } from 'react';
import {
  Paper,
  Typography,
  TextField,
  Button,
  Box,
  Alert,
  Container
} from '@mui/material';
import { Login as LoginIcon } from '@mui/icons-material';
import { supabase } from '../supabaseClient';

// Map of usernames to their actual Supabase Auth email addresses
const USERNAME_EMAIL_MAP = {
  admin: 'anshul.shukla0211@gmail.com',
  anshul: 'anshul.shukla0211@gmail.com',
  sudhanshu: 'stripathi@jmdsupplychainsolutions.in',
  sss: 'sales@nwll.in',
  manoj: 'finance@nwll.in',
  vinay: 'vinayshukla@jmdsupplychainsolutions.in'
};

const Login = () => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [alert, setAlert] = useState({ show: false, message: '', severity: 'error' });
  const [loading, setLoading] = useState(false);

  const handleChange = (field, value) => {
    setCredentials(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setAlert({ show: false, message: '', severity: 'error' });

    try {
      let input = credentials.username.trim();
      let email = input;

      // Support logging in by either username or full email address
      if (!email.includes('@')) {
        const mappedEmail = USERNAME_EMAIL_MAP[input.toLowerCase()];
        email = mappedEmail || `${input.toLowerCase()}@billauto.internal`;
      }

      const { error } = await supabase.auth.signInWithPassword({
        email,
        password: credentials.password
      });

      if (error) {
        throw error;
      }
      
      // React state update is automatically handled in App.js by onAuthStateChanged subscription
    } catch (error) {
      setAlert({
        show: true,
        message: error.message || 'Login failed. Please check your credentials.',
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Paper sx={{ p: 4, width: '100%' }}>
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <Typography variant="h4" gutterBottom>
              Bill Automation System
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Sign in to continue (use username or email)
            </Typography>
          </Box>

          {alert.show && (
            <Alert severity={alert.severity} onClose={() => setAlert({ ...alert, show: false })} sx={{ mb: 2 }}>
              {alert.message}
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Username or Email"
              value={credentials.username}
              onChange={(e) => handleChange('username', e.target.value)}
              margin="normal"
              required
              autoFocus
            />
            <TextField
              fullWidth
              label="Password"
              type="password"
              value={credentials.password}
              onChange={(e) => handleChange('password', e.target.value)}
              margin="normal"
              required
            />
            <Button
              fullWidth
              variant="contained"
              size="large"
              type="submit"
              startIcon={<LoginIcon />}
              sx={{ mt: 3 }}
              disabled={loading}
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </Button>
          </form>
        </Paper>
      </Box>
    </Container>
  );
};

export default Login;
